import { useCallback, useState } from "react";
import { SearchState } from "../types";

export function useSubQueryPreview() {
  const [state, open] = useState<SearchState>();
  const close = useCallback(() => open(undefined), []);
  return { state, open, close };
}
